import packageInfo from './package.json';

export const APP_VERSION: string = packageInfo?.version ?? '0.0.0';
